export const blockIconsCommonactionsLightbulbNew = (
	<span className='material-symbols-outlined'>lightbulb</span>
);
